// Copyright 2025, University of Maryland, All Rights Reserved
import type { KnowledgeBaseSettingKey } from '../types'

export type RawKnowledgeBaseSettings = Record<string, unknown>

export function readSettingsFromConfig(config: unknown): RawKnowledgeBaseSettings {
  if (!config || typeof config !== 'object' || Array.isArray(config)) {
    return {}
  }

  const root = config as Record<string, unknown>
  const nested = root.settings
  if (nested && typeof nested === 'object' && nested !== null && !Array.isArray(nested)) {
    return nested as RawKnowledgeBaseSettings
  }

  return root
}

export function resolveSettingValue(
  settings: RawKnowledgeBaseSettings,
  key: KnowledgeBaseSettingKey,
  fallback = '',
): string {
  const value = settings[key]
  return typeof value === 'string' ? value : fallback
}
